﻿import React, {FC} from 'react';
import {Grid, GridTypeMap} from "@mui/material";
import {OverridableComponent} from "@mui/material/OverridableComponent";

/**
 * Container for individual {@link SortFilterItemContainer} components.
 * Simple wrapper around MUI Grid item. Content belongs in this component's children.
 *
 * @see {@link SortFilterItemContainer}
 *
 * @example
 * <SortFilterContainer>
 *   <SortFilterItemContainer sm={6}>
 *     <!-- Sort/filter item content here -->
 *   </SortFilterItemContainer>
 * </SortFilterItemContainer>
 *
 * @param props - See {@link Grid} API for available props
 * @constructor
 */
const SortFilterContainer: FC<any> = (props: OverridableComponent<GridTypeMap>) => {
  return <Grid container flexDirection={'column'} {...props} />
}

export { SortFilterContainer };
